import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/4_orange/4_orange"
 * Contains 1 texture(s)
 */
export class Mobile4OrangeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/4_orange/4_orange';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '4_orange.png'
    ] as const;
}
